import React, { useState } from 'react';
import PropTypes from 'prop-types';

import createStyle from 'shared-utils/src/createStyle';

import styles, { mainCls } from './style';

const useStyles = createStyle(styles);

const Picture = ({ data, onClick }) => {
  const [imgUrl, setImgUrl] = useState(data.uri)
  const showPlaceholder = () => setImgUrl('/mobileplaceholder.jpg');

  const cls = useStyles();
  const src ={
    sml: `${data.baseUri}800x600${imgUrl}`,
    big: `${data.baseUri}1052x798${imgUrl}`,
  };

  const onClickAction = () => onClick && onClick();

  return (
    <picture
      className={`${cls[mainCls]} is-rel`}
      onClick={onClickAction}
    >
      <source media="(min-width:1024px)" srcSet={src.big} />
      <img
        className={`${cls[`${mainCls}__img`]}${onClick ? ' is-clickable' : ''}`}
        src={src.sml}
        alt={data.alt}
        onError={showPlaceholder}
      />
    </picture>
  );
};

export default Picture;

Picture.propTypes = {
  data: PropTypes.instanceOf(Object),
  onClick: PropTypes.func,
};

Picture.defaultProps = {
  onClick: null,
};